import { createAction } from 'redux-actions';
import { VISITORS_INVALIDATED } from '../constants/realtimeActionTypes';
export const visitorsInvalidated = createAction(VISITORS_INVALIDATED, ({
  threadId,
  vid
}) => ({
  threadId,
  vid
}));